import { UserStatus } from 'types'

export const userStatuses = [
  { title: 'Verified', value: UserStatus.Verified },
  { title: 'Not verified', value: UserStatus.NotVerified },
]
